import { render, staticRenderFns } from "./LookupValue.vue?vue&type=template&id=bb991292"
import script from "./LookupValue.vue?vue&type=script&lang=js"
export * from "./LookupValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports